import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { ServiceHelper } from '../config';
import { AuctionModel } from '../models';
import { AppConfig } from '../config';
import * as moment from 'moment-timezone';

@Injectable()
export class AuctionService {
    initialized: boolean = false;
    auction: AuctionModel;
    auctions: AuctionModel[] = [];

    constructor(public http: HttpClient, public serviceHelper: ServiceHelper, private appConfig: AppConfig) {
        var me = this;

        me.InitialiseAuctions();
    }

    InitialiseAuctions() {
        var me = this;

        forkJoin([
            me.GetAuctions(),
            me.CurrentAuction()
        ]).subscribe(([data1, data2]) => {
            // GetAuctions
            me.auctions = [];
            me.auctions = data1.map(x => {
                var data = Object.assign(new AuctionModel(), x);
                //console.log('data', data);
                if (data?.OpenDate) data.OpenDate = moment.tz(data.OpenDate, 'Australia/Melbourne').toDate();
                if (data?.CloseDate) data.CloseDate = moment.tz(data.CloseDate, 'Australia/Melbourne').toDate();
                return data;
            });
            me.auctions?.sort((a, b) => +new Date(b.OpenDate) - +new Date(a.OpenDate));

            // CurrentAuction
            me.auction = data2;

            if (data2?.OpenDate) me.auction.OpenDate = moment.tz(data2.OpenDate, 'Australia/Melbourne').toDate();
            if (data2?.CloseDate) me.auction.CloseDate = moment.tz(data2.CloseDate, 'Australia/Melbourne').toDate();
            me.initializeTimer();

            if (me.auctions?.length || me.auction) me.initialized = true;
        });

        // me.GetAuctions().subscribe(data => {
        //     me.auctions = data.map(x => {
        //         var data = Object.assign(new AuctionModel(), x);
        //         //console.log('data', data);
        //         if (data?.OpenDate) data.OpenDate = moment.tz(data.OpenDate, 'Australia/Melbourne').toDate();
        //         if (data?.CloseDate) data.CloseDate = moment.tz(data.CloseDate, 'Australia/Melbourne').toDate();
        //         return data;
        //     });
        //     me.auctions?.sort((a, b) => +new Date(b.OpenDate) - +new Date(a.OpenDate));
        //     if (me.auction) me.initialized = true;
        // });

        // me.CurrentAuction().subscribe(data => {
        //     me.auction = data;
        //     console.log('current auction', data);
        //     if (data?.OpenDate) me.auction.OpenDate = moment.tz(data.OpenDate, 'Australia/Melbourne').toDate();
        //     if (data?.CloseDate) me.auction.CloseDate = moment.tz(data.CloseDate, 'Australia/Melbourne').toDate();
        //     me.initializeTimer();

        //     if (me.auctions?.length) me.initialized = true;
        // });
    }

    CurrentAuction(): Observable<AuctionModel> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        // console.log('GetCurrentAuction');

        return this.http.get<AuctionModel>(this.appConfig.getConfig('apiUrl') + '/auctions/current', { withCredentials: true, headers: headers });
    }

    GetAuctions(): Observable<AuctionModel[]> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        // console.log('GetAuctions');

        return this.http.get<AuctionModel[]>(this.appConfig.getConfig('apiUrl') + '/auctions', { withCredentials: true, headers: headers });
    }

    timer;
    auctionClosing = {
        available: false,
        isOpenStatus: false,
        nextOpenDate: null,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    };

    initializeTimer() {
        let me = this;

        let data = me.auction;

        if (data) {

            // if (data?.OpenDate) data.OpenDate = moment.tz(data.OpenDate, 'Australia/Melbourne').toDate();
            // if (data?.CloseDate) data.CloseDate = moment.tz(data.CloseDate, 'Australia/Melbourne').toDate();
            console.log('timer data', data);
            console.log(data.OpenDate);
            console.log(data.CloseDate);

            me.timeBetweenDates(data.CloseDate);
            me.timer = setInterval(function () {
                me.timeBetweenDates(data.CloseDate);
            }, 1000);
        } else {
            // Reset timer
            clearInterval(me.timer);
            // me.timer = null;
            me.auctionClosing.available = false;
            me.auctionClosing.isOpenStatus = false;
            me.auctionClosing.nextOpenDate = null;
            me.auctionClosing.days = 0;
            me.auctionClosing.hours = 0;
            me.auctionClosing.minutes = 0;
            me.auctionClosing.seconds = 0;
        }

        // me.CurrentAuction().subscribe(data => {
        //     console.log('data', data);
        //     if (data) {

        //         if (data?.OpenDate) data.OpenDate = moment.tz(data.OpenDate, 'Australia/Melbourne').toDate();
        //         if (data?.CloseDate) data.CloseDate = moment.tz(data.CloseDate, 'Australia/Melbourne').toDate();

        //         console.log(data.OpenDate);
        //         console.log(data.CloseDate);

        //         me.timeBetweenDates(data.CloseDate);
        //         me.timer = setInterval(function () {
        //             me.timeBetweenDates(data.CloseDate);
        //         }, 1000);
        //     } else {
        //         // Reset timer
        //         this.auctionClosing.available = false;
        //         this.auctionClosing.isOpenStatus = false;
        //         this.auctionClosing.nextOpenDate = null;
        //         this.auctionClosing.days = 0;
        //         this.auctionClosing.hours = 0;
        //         this.auctionClosing.minutes = 0;
        //         this.auctionClosing.seconds = 0;
        //     }
        // });


    }
    timeBetweenDates(toDate: Date) {
        if (!toDate)
            return;
        var dateEntered = toDate;
        var now = new Date();
        var difference = dateEntered.getTime() - now.getTime();
        this.auctionClosing.available = true;

        if (difference <= 0) {

            // Timer done
            clearInterval(this.timer);

        } else {

            var seconds = Math.floor(difference / 1000);
            var minutes = Math.floor(seconds / 60);
            var hours = Math.floor(minutes / 60);
            var days = Math.floor(hours / 24);

            hours %= 24;
            minutes %= 60;
            seconds %= 60;

            this.auctionClosing.days = days;
            this.auctionClosing.hours = hours;
            this.auctionClosing.minutes = minutes;
            this.auctionClosing.seconds = seconds;
        }
    }
}